import { ModalDetails } from 'business/models/CustomModels';
import ModelFactory from 'business/models/ModelFactory';
import {
  CaptureProfileClient,
  CaptureProfileDTO,
  ImageZoomDTO,
  InspectionSetDTO,
  RegionsDTO,
  SystemTaskResponseDTO,
} from 'business/models/Models';
import CaptureProfileRendrer from 'components/commandpanel/ImageNow/CaptureProfileRenderer';
import { RMCheckBoxY } from 'components/customComponents/Controls/RMCheckbox';
import { ReportOption } from 'components/reports/ExperimentReportOptions';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import React, { useEffect, useState } from 'react';
import { showAlertSnackBar, showSnackBar, UpdateArray } from 'utils/Global';
import './SaveImage.scss';
import { useSelectedDropImageParameters } from 'redux/hooks/experiment';
import { useSaveWellIDropImage } from '../WellImage/hooks';
import { useImageZoomVisibleArea } from 'components/well/hooks';
let selectedCaptureProfiles: number[] = [];
let checkedState: boolean[] = [];

export interface SaveWellDropImageParams {
  selectedCaptureProfileIds: number[];
  saveAllDrops: boolean;
  saveAllRegions: boolean;
  saveAllInspections: boolean;
  saveAllFocusLevels: boolean;
  saveAllWellDropScores: boolean;
  saveAnnotations: boolean;
  saveScaleBar?: boolean;
  saveCurrentZoom: boolean;
  imageZoomDto?: ImageZoomDTO;
  saveIngredientInfo?: boolean;
  onCompleteSaveImage: (res: any) => void;
  onErrorSaveImage: (res: any) => void;
}

interface Props {
  setRefSaveImage: (saveImage) => void;
  regions: RegionsDTO[];
  inspections: InspectionSetDTO[];
  modalDetails: ModalDetails;
  setModalDetails: (modalDetails: ModalDetails) => void;
  setModalOkDisabled: (modalOkDisabled: boolean) => void;
}
interface optionsDTO {
  label: string;
  isChecked: boolean;
  id: string;
  disabled?: boolean;
  onChange: (e?) => void;
}
export default function SaveImage(props: Props) {
  const { setRefSaveImage, modalDetails, setModalDetails, setModalOkDisabled } = props;
  const [captures, setCaptures] = useState<CaptureProfileDTO>(null);
  const [allDrops, setAllDrops] = useState(false);
  const [allInspections, setAllInspections] = useState(false);
  const [allRegions, setAllRegions] = useState(true);
  const [focusLevel, setFocusLevel] = useState(false);
  const [wellDropScore, setWellDropScore] = useState(true);
  const [annotations, setAnnotations] = useState(false);
  const [currentZoom, setCurrentZoom] = useState(false);
  const [expDetails, setExpDetails] = useState(false);
  const [saveIngredientInfo, setSaveIngredientInfo] = useState<boolean>(false);
  const [isRegionImage, setIsRegionImage] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { saveWellDropImage } = useSaveWellIDropImage();
  const { imageZoomVisibleArea } = useImageZoomVisibleArea();

  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { cpId, regionName } = selectedDropImageParameters || {};
  const saveDetails: optionsDTO[] = [
    {
      label: 'Save All Drops from Selected Well(s)',
      isChecked: allDrops,
      id: 'allDrops',
      onChange: () => setAllDrops(!allDrops),
    },
    {
      label: 'Save All Regions',
      isChecked: allRegions,
      id: 'allRegions',
      disabled: isRegionImage,
      onChange: () => setAllRegions(!allRegions),
    },
    {
      label: 'Save All Inspections',
      isChecked: allInspections,
      id: 'allInspections',
      onChange: () => setAllInspections(!allInspections),
    },
    {
      label: 'Save Focus Level Images',
      isChecked: focusLevel,
      id: 'focusLevel',
      onChange: () => setFocusLevel(!focusLevel),
    },
    {
      label: 'Save Well Drop Scores',
      isChecked: wellDropScore,
      id: 'wellDropScore',
      onChange: () => setWellDropScore(!wellDropScore),
    },
  ];
  const saveOptions: optionsDTO[] = [
    {
      label: 'Save annotations',
      isChecked: annotations,
      id: 'annotations',
      onChange: () => setAnnotations(!annotations),
    },
    {
      label: 'Use Current Zoom',
      isChecked: currentZoom,
      id: 'currentZoom',
      onChange: () => setCurrentZoom(!currentZoom),
    },
    {
      label: 'Save Ingredient Info',
      isChecked: saveIngredientInfo,
      id: 'saveIngredientInfo',
      onChange: () => setSaveIngredientInfo(!saveIngredientInfo),
    },
    {
      label: 'Save Experiment Details',
      isChecked: expDetails,
      id: 'expDetails',
      disabled: true,
      onChange: () => setExpDetails(!expDetails),
    },
  ];
  useEffect(() => {
    selectedCaptureProfiles = [];
    checkedState = [];

    if (captures == null) {
      setModalOkDisabled(true);
      fetchData().then((cps) => {
        checkedState = new Array(cps.captureProfileRows.length).fill(false);
        const cpIndex = cps.captureProfileRows.findIndex((cp) => cp.id == cpId);
        if (cpIndex >= 0) {
          captureHandler(cpIndex, cps.captureProfileRows[cpIndex].id);
        }
        setCaptures(cps);
      });
    }
  }, []);
  useEffect(() => {
    setRefSaveImage(saveImage);
  });

  async function saveImage() {
    if (selectedCaptureProfiles.length === 0) {
      showSnackBar('Please select any capture profile to export.');
      return;
    }
    setModalDetails({ ...modalDetails, showModal: false });

    const saveImageParams: SaveWellDropImageParams = {
      selectedCaptureProfileIds: selectedCaptureProfiles,
      saveAllDrops: allDrops,
      saveAllRegions: allRegions,
      saveAllInspections: allInspections,
      saveAllFocusLevels: focusLevel,
      saveAllWellDropScores: wellDropScore,
      saveAnnotations: annotations,
      saveCurrentZoom: currentZoom,
      imageZoomDto: imageZoomVisibleArea as ImageZoomDTO,
      saveIngredientInfo: saveIngredientInfo,
      onCompleteSaveImage,
      onErrorSaveImage,
    };
    saveWellDropImage(saveImageParams);
  }

  const onErrorSaveImage = (response: SystemTaskResponseDTO) => {
    showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, response.message);
  };

  function onCompleteSaveImage(response) {
    if (
      !response?.responseFile?.data ||
      response.responseFile?.data.size == 0 ||
      !response
    ) {
      showAlertSnackBar(EAlertType.WARNING, ESnackBarPosition.TOP, 'No files found!');
      return;
    }
    const { data, fileName } = response.responseFile;
    const url = URL.createObjectURL(data);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    // Clean up and remove the link
    a.parentNode.removeChild(a);
    // setShowLoading(false);
    showAlertSnackBar(
      EAlertType.SUCCESS,
      ESnackBarPosition.TOP,
      'File succesfully downloaded!',
    );
  }
  async function fetchData(): Promise<CaptureProfileDTO> {
    const isDisabledAllRegion =
      regionName === 'Overview' || regionName.toLowerCase().includes('region');
    setIsRegionImage(isDisabledAllRegion);
    const cpClinet: CaptureProfileClient = ModelFactory(CaptureProfileClient);
    const captureProfiles: CaptureProfileDTO = await cpClinet.getCaptureProfile();
    return captureProfiles;
  }
  function captureHandler(position, id) {
    const updatedCheckedState = checkedState.map((item, index) => {
      const status = index === position;
      if (status) {
        UpdateArray(selectedCaptureProfiles, id, !item);
      }
      return status ? !item : item;
    });
    checkedState = updatedCheckedState;
    setRefresh(!refresh);
    setModalOkDisabled(selectedCaptureProfiles.length === 0);
  }
  return (
    <div id="saveimage-main-container">
      <div id="saveimage-warning-message" className="text-p mb-2 font-bold">
        Please select at least an imaging setting, an image preference, and a saving
        option.
      </div>
      <div
        id="saveimage-menu-wrapper"
        className="d-flex h-100 p-2 flex-column saveImage"
        style={{ height: '40rem' }}
      >
        <div id="saveimage-menu-option" className="d-flex flex-row h-90">
          <div
            id="saveimage-menu-option-captureprofile"
            className="flex-60 divider-right p-2 d-flex flex-column overflow-auto"
          >
            <CaptureProfileRendrer
              captures={captures}
              checkedState={checkedState}
              captureHandler={captureHandler}
              isCompactUI={true}
            />
          </div>
          <div id="saveimage-menu-option-checkbox" className="flex-40 p-2">
            <div
              id="saveimage-menu-option-checkbox-preferences"
              className="saveImage-title"
            >
              Preferences
            </div>
            {checkBoxWithLabelsRenderer(saveDetails)}
            <div
              id="saveimage-menu-option-checkbox-saveoptions"
              className="saveImage-title"
            >
              Save Options
            </div>
            {checkBoxWithLabelsRenderer(saveOptions)}
          </div>
        </div>
      </div>
    </div>
  );
}
const checkBoxWithLabelsRenderer = (options: optionsDTO[]) => {
  return options.map((d, i) => {
    return (
      <ReportOption
        key={`reportOpt${i}`}
        input={
          <RMCheckBoxY
            isChecked={d.isChecked}
            onChange={d.onChange}
            disabled={d.disabled}
          />
        }
        label={d.label}
      />
    );
  });
};
